import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const MitidIcon = (props: SvgIconProps) => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <rect width="48" height="48" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.5714 14.3077H30.009C38.4331 14.3077 42 18.6819 42 24.1538C42 29.6258 38.4331 34 30.009 34H26.5714V14.3077ZM24.0001 34H6C6.5131 27.9276 10.3191 25.3846 15 25.3846C19.681 25.3846 23.487 27.9276 24.0001 34ZM19.9822 18.7692C19.9822 21.4033 17.7515 23.5385 15 23.5385C12.2484 23.5385 10.0179 21.4033 10.0179 18.7692C10.0179 16.1353 12.2484 14 15 14C17.7515 14 19.9822 16.1353 19.9822 18.7692Z"
            fill="#0060E6"
        />
    </SvgIcon>
);

export default MitidIcon;
